/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React, { useEffect, useRef } from "react";
import Amenities from "../../../components/project/Amenities";
import Banner from "../../../components/project/Banner";
import Landmarks from "../../../components/project/Landmarks";
import ProjectOverview from "../../../components/project/ProjectOverview";
import SimilarProjects from "../../../components/project/SimilarProjects";
import Tomorrow from "../../../components/home/Tomorrow";
import Facilities from "../../../components/project/Facilities";
import Masterplan from "../../../components/project/Masterplan";
import { NextSeo } from "next-seo";
import { QueryClient, useQuery, dehydrate } from "react-query";
import { BASE_URL, fetchDynamicData } from "../../../utils/FetchData";
import { useRouter } from "next/router";
import { useState } from "react";
import Enquiry from "../../../components/phase/Enquiry";
import PhaseOverview from "../../../components/phase/PhaseOverview";
import BuildingType from "../../../components/phase/BuildingType";
import NavTabs from "../../../components/common/NavTabs";
import NavTabsWithCommercialServices from "../../../components/common/NavTabsWithCommercialServices";
import NavTabsCommercial from "../../../components/common/NavTabsCommercial";
import NavTabsBusiness from "../../../components/common/NabTabsBusiness";
import LoadingPage from "../../../components/LoadingPage";
import ConstructionUpdates from "../../../components/phase/ConstructionUpdates";
import Footer from "@/components/common/Footer";
import { Fragment } from "react";
import { useContext } from "react";
import { isMobileContext } from "@/contexts/isMobileContext";
const index = ({ slug }) => {
	const { isMobile } = useContext(isMobileContext)
	const [orderedPhases, setOrderedPhases] = useState()
	const [masterPlanFacilities, setMasterPlanFacilities] = useState()
	const { t } = useTranslation("common");
	const { locale } = useRouter()
	const overview = useRef();
	const facilities = useRef();
	const amenities = useRef()
	const landmarks = useRef()
	const similarProjects = useRef()
	const masterplan = useRef()
	const enquire = useRef()
	const building = useRef();
	const foodCourt = useRef();
	const signature = useRef();
	const construction = useRef();
	const masterPalnSearch = useRef();
	const commercialServices = useRef();
	const [navlist, setNavlist] = useState([
		{ id: 1, text: t("navTabs.project_overview"), path: overview },
		{ id: 2, text: t("navTabs.masterplan"), path: masterplan },
		{ id: 3, text: t("navTabs.amenities_services"), path: amenities },
		{ id: 4, text: t("navTabs.facilities"), path: facilities },
		{ id: 5, text: t("navTabs.landmarks"), path: landmarks },
		{ id: 6, text: t("navTabs.similar_projects"), path: similarProjects },
		{ id: 7, text: t("navTabs.enquire"), path: enquire },
	])
	const [navlistWithCommercialServices, setNavlistWithCommercialServices] = useState([
		{ id: 1, text: t("navTabs.project_overview"), path: overview },
		{ id: 2, text: t("navTabs.masterplan"), path: masterplan },
		{ id: 3, text: t("navTabs.amenities_services"), path: amenities },
		{ id: 4, text: t("navTabs.facilities"), path: facilities },
		{ id: 5, text: t("navTabs.landmarks"), path: landmarks },
		{ id: 6, text: t("navTabs.commercialServices"), path: commercialServices },
		{ id: 7, text: t("navTabs.similar_projects"), path: similarProjects },
		{ id: 8, text: t("navTabs.enquire"), path: enquire },
	])
	const [navBusinessList, setNavBusinessList] = useState([
		{ id: 1, text: t("navTabs.project_overview"), path: overview },
		{ id: 2, text: t("common.office_type"), path: building },
		{ id: 4, text: t("navTabs.amenities_services"), path: amenities },
		{ id: 5, text: t("navTabs.enquire"), path: enquire },
	])

	const [navCommercialList, setavCommercialList] = useState([
		{ id: 1, text: t("navTabs.project_overview"), path: overview },
		{ id: 2, text: t("navTabs.signature_outlets"), path: signature },
		{ id: 3, text: t("navTabs.foodCourt"), path: foodCourt },
		{ id: 4, text: t("navTabs.facilities"), path: facilities },
		{ id: 5, text: t("navTabs.enquire"), path: enquire },
	])
	const [projectData, setProjectData] = useState();
	const [businessProjectData, setBusinessProjectData] = useState();
	const [commercialProjectData, setCommercialProjectData] = useState();
	//normalProjects fetching
	const { data, isSuccess, isLoading, isError } = useQuery(["projectDetails", locale], () => fetchDynamicData(
		'projects', slug, locale,
		'populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=Project_Overview.Project_Info.Icon&populate[3]=Project_Master_Plan.Map_Mobile&populate[4]=Project_Master_Plan.Map_Desktop&populate[5]=Project_Master_Plan.Phase_Project.Logo&populate[6]=Project_Master_Plan.Phase_Project.Icon&populate[7]=Project_Master_Plan.Phase_Project.Pdf&populate[8]=Project_Master_Plan.Phase_Project.Img_Desktop&populate[9]=Project_Master_Plan.Phase_Project.Img_Mobile&populate[10]=Project_Master_Plan.Phase_Project.Thumbnails_Mobile&populate[11]=Project_Master_Plan.Phase_Project.Thumbnails_Desktop&populate[12]=Amenities_Services.Amenitie_Service.Icon&populate[13]=Facilities.Img_Desktop&populate[14]=Facilities.Img_Mobile&populate[15]=Facilities.Our_Facilities.Img_Desktop&populate[16]=Facilities.Our_Facilities.Img_Mobile&populate[17]=Landmarks.Img_Desktop&populate[18]=Landmarks.Img_Mobile&populate[19]=Project_Card.Img_Mobile&populate[20]=Project_Card.Project_Info.Icon&populate[21]=Project_Card.Img_Desktop&populate[22]=Home_Card.Img_Desktop&populate[23]=Home_Card.Img_Mobile&populate[24]=Home_Card.Logo&populate[25]=Similar_Projects.Projects&populate[26]=Similar_Projects.Phases&populate[27]=Similar_Projects.Projects.Project_Card.Img_Mobile&populate[28]=Similar_Projects.Projects.Project_Card.Project_Info.Icon&populate[29]=Similar_Projects.Projects.Project_Card.Img_Desktop&populate[30]=phases&populate[31]=phases.Master_Plan_Card&populate[32]=phases.Master_Plan_Card.Icon&populate[33]=phases.Master_Plan_Card.Pdf&populate[34]=phases.Master_Plan_Card.Img_Desktop&populate[35]=phases.Master_Plan_Card.Img_Mobile&populate[36]=phases.Master_Plan_Card.Thumbnails_Desktop&populate[38]=phases.Master_Plan_Card.Logo&populate[39]=About_Project&populate[40]=About_Project.Project_Usps.Small_Img_Mobile&populate[41]=About_Project.Project_Usps.Small_Img_Desktop&populate[42]=About_Project.Project_Usps.Big_Img_Mobile&populate[43]=About_Project.Project_Usps.Big_Img_Desktop&populate[44]=Commercial_Services&populate[45]=Commercial_Services.Services&populate[46]=Commercial_Services.Services.Icon&populate[47]=Construction_Updates.Main_Slider.Img_Mobile&populate[48]=Construction_Updates.Main_Slider.Img_Desktop&populate[49]=Construction_Updates.Sub_Slider.Img_Desktop&populate[50]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[51]=phases.Phase_Building&&populate[52]=form_image_desktop&&populate[53]=form_image_mobile&&populate[54]=Facilities.Our_Facilities.Masterplan_Img_Mobile&&populate[55]=Facilities.Our_Facilities.Masterplane_Img_Desktop&&populate[56]=Facilities.Our_Facilities.Masterplane_Description&&populate[57]=Construction_Updates.Main_Slider.Sub_Slider_Img&&populate[58]=SEO.Img'
	), {
		enabled: slug?.slice(0, 2) != "Cp" && slug?.slice(0, 2) != "Bp"
	})
	//businessProjects fetching
	const {
		data: businessData,
		isLoading: businessIsLoading,
		isError: businessIsError,
		isFetching: businessIsFetching,
		isSuccess: businessIsSuccess } = useQuery(['projectDetailsBusiness'], () => fetchDynamicData(
			'businesses',
			slug,
			locale,
			'populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=About_Project.Project_Usps.Small_Img_Desktop&populate[3]=About_Project.Project_Usps.Small_Img_Mobile&populate[4]=About_Project.Project_Usps.Big_Img_Desktop&populate[5]=About_Project.Project_Usps.Big_Img_Mobile&populate[6]=Office_Building.Img_Desktop&populate[7]=Office_Building.Img_Mobile&populate[8]=Office_Building.Building_Details.Icon&populate[9]=Office_Building.Pdf&populate[10]=FacilitiesAndServices.Amenitie_Service.Icon&populate[11]=project_tabs&populate[12]=Home_Card.Img_Desktop&populate[13]=Home_Card.Img_Mobile&populate[14]=Home_Card.Img_Logo&populate[15]=Project_Overview.Project_Info.Icon&populate[16]=Construction_Updates.Main_Slider.Img_Mobile&populate[17]=Construction_Updates.Main_Slider.Img_Desktop&populate[18]=Construction_Updates.Sub_Slider.Img_Desktop&populate[19]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[20]=Facilities.Our_Facilities.Masterplan_Img_Mobile&&populate[21]=Facilities.Our_Facilities.Masterplane_Img_Desktop&&populate[22]=Facilities.Our_Facilities.Masterplane_Description&&populate[23]=form_image_desktop&&populate[24]=form_image_mobile&&populate[25]=Construction_Updates.Main_Slider.Sub_Slider_Img&&populate[26]=SEO.Img'
		), {
			enabled: slug?.slice(0, 2) == "Bp"
		})
	//commercialProjects fetching
	const {
		data: commercialData,
		isLoading: commercialIsLoading,
		isError: commercialIsError,
		isFetching: commercialIsFetching,
		isSuccess: commercialIsSuccess,
	} = useQuery(['projectDetailsCommercial'], () => fetchDynamicData(
		'commercials',
		slug,
		locale,
		'populate[0]=Banner.Slider&populate[1]=Banner.Slider.Img_Desktop&populate[2]=Banner.Slider.Img_Mobile&populate[3]=About_Project.Project_Usps.Small_Img_Desktop&populate[4]=About_Project.Project_Usps.Small_Img_Mobile&populate[5]=About_Project.Project_Usps.Big_Img_Desktop&populate[6]=About_Project.Project_Usps.Big_Img_Mobile&populate[7]=Master_Plan.Img_Desktop&populate[8]=Master_Plan.Img_Mobile&populate[9]=Signature_Restauran.Food_Restaurant.img_desktop&populate[10]=Signature_Restaurant.Food_Restaurant.img_mobile&populate[11]=Food_Court.Restaurants.Icon&populate[12]=Facilities.Img_Desktop&populate[13]=Facilities.Img_Mobile&populate[14]=Facilities.Our_Facilities.Img_Desktop&populate[15]=Facilities.Our_Facilities.Img_Mobile&populate[16]=project_tabs.commercial_projects&populate[17]=Signature_Restaurant.Food_Restaurant.Icon&populate[18]=Construction_Updates.Main_Slider.Img_Mobile&populate[19]=Construction_Updates.Main_Slider.Img_Desktop&populate[20]=Construction_Updates.Sub_Slider.Img_Desktop&populate[21]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[22]=Facilities.Our_Facilities.Masterplan_Img_Mobile&&populate[23]=Facilities.Our_Facilities.Masterplane_Img_Desktop&&populate[24]=Facilities.Our_Facilities.Masterplane_Description&&populate[25]=form_image_desktop&&populate[26]=form_image_mobile&&populate[27]=Construction_Updates.Main_Slider.Sub_Slider_Img&&populate[28]=SEO.Img'
	), {
		enabled: slug?.slice(0, 2) == "Cp"
	})

	useEffect(() => {
		isSuccess && setProjectData(data?.data[0]?.attributes)
	}, [data, isSuccess])

	useEffect(() => {
		businessIsSuccess && setBusinessProjectData(businessData?.data[0]?.attributes)
	}, [businessData, businessIsSuccess])

	useEffect(() => {
		commercialIsSuccess && setCommercialProjectData(commercialData?.data[0]?.attributes)
	}, [commercialData, commercialIsSuccess])

	useEffect(() => {
		const order = []
		projectData?.phases?.data?.sort((a, b) => a.attributes.Order - b.attributes.Order).map(phase => {
			order.push(phase)
		})
		setOrderedPhases(order)
	}, [projectData])

	useEffect(() => {
		const masterFacility = []
		projectData?.Facilities?.Our_Facilities?.map(facility => {
			facility?.Show_In_Masterplan &&
				masterFacility.push(facility)
		})
		setMasterPlanFacilities(masterFacility)
	}, [projectData])

	useEffect(() => {
		projectData?.Construction_Updates ?
			(
				setNavlist(
					[
						{ id: 1, text: t("navTabs.project_overview"), path: overview },
						{ id: 2, text: t("navTabs.masterplan"), path: masterplan },
						{ id: 3, text: t("navTabs.amenities_services"), path: amenities },
						{ id: 4, text: t("navTabs.facilities"), path: facilities },
						{ id: 5, text: t("navTabs.landmarks"), path: landmarks },
						{ id: 6, text: t("navTabs.construction_updates"), path: construction },
						{ id: 7, text: t("navTabs.similar_projects"), path: similarProjects },
						{ id: 8, text: t("navTabs.enquire"), path: enquire },
					]),
				setNavlistWithCommercialServices([
					{ id: 1, text: t("navTabs.project_overview"), path: overview },
					{ id: 2, text: t("navTabs.masterplan"), path: masterplan },
					{ id: 3, text: t("navTabs.amenities_services"), path: amenities },
					{ id: 4, text: t("navTabs.facilities"), path: facilities },
					{ id: 5, text: t("navTabs.landmarks"), path: landmarks },
					{ id: 6, text: t("navTabs.commercialServices"), path: commercialServices },
					{ id: 7, text: t("navTabs.construction_updates"), path: construction },
					{ id: 8, text: t("navTabs.similar_projects"), path: similarProjects },
					{ id: 9, text: t("navTabs.enquire"), path: enquire },
				])
			)
			: ""
	}, [projectData?.Construction_Updates, t])

	useEffect(() => {
		commercialProjectData?.Construction_Updates ?
			setavCommercialList([
				{ id: 1, text: t("navTabs.project_overview"), path: overview },
				{ id: 2, text: t("navTabs.signature_outlets"), path: signature },
				{ id: 3, text: t("navTabs.foodCourt"), path: foodCourt },
				{ id: 4, text: t("navTabs.facilities"), path: facilities },
				{ id: 5, text: t("navTabs.construction_updates"), path: construction },
				, { id: 6, text: t("navTabs.enquire"), path: enquire },
			])
			: ""
	}, [commercialProjectData?.Construction_Updates, t])

	useEffect(() => {
		businessProjectData?.Construction_Updates ?
			setNavBusinessList([
				{ id: 1, text: t("navTabs.project_overview"), path: overview },
				{ id: 2, text: t("common.office_type"), path: building },
				{ id: 3, text: t("navTabs.construction_updates"), path: construction },
				{ id: 4, text: t("navTabs.amenities_services"), path: amenities },
				{ id: 5, text: t("navTabs.enquire"), path: enquire },
			])
			: ""
	}, [businessProjectData?.Construction_Updates, t])

	const [pageLoading, setPageLoading] = useState(true)

	useEffect(() => {
		let timeOut = ''
		if (projectData && !pageLoading && localStorage.getItem('phase')) {
			timeOut = setTimeout(() => {
				masterplan?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
				localStorage.removeItem("phase")
			}, 2500)
		}
		return () => clearTimeout(timeOut)
	}, [projectData, pageLoading])

	useEffect(() => {
		setPageLoading(true)
		let timeOut = ''
		if (slug) {
			setPageLoading(true)
			timeOut = setTimeout(() => {
				setPageLoading(false)
			}, 2500)
		}
		return () => clearTimeout(timeOut)
	}, [slug])

	// if (isLoading || commercialIsLoading || businessIsLoading || pageLoading) {
	// 	return <LoadingPage />;
	// }

	if (
		data?.error?.status == 404 || isError ||
		commercialData?.error?.status == 404 || commercialIsError ||
		businessData?.error?.status == 404 || businessIsError

	) {
		return <LoadingPage error />;
	}
	return (
		<>
			<LoadingPage pageLoading={pageLoading} />
			{businessProjectData ?
				//business projects structure
				<>
					<NextSeo
							title={businessData?.data[0]?.attributes?.SEO?.Title}
							description={businessData?.data[0]?.attributes?.SEO?.Description}
							openGraph={{
								type: 'website',
								url: `https://www.hydeparkdevelopments.com/projects/${slug}`,
								title: businessData?.data[0]?.attributes?.SEO?.Title,
								images: [
									{ url: BASE_URL + businessData?.data[0]?.attributes?.SEO?.Img?.data?.attributes?.url },
								],
								siteName: 'Hyde Park Developments',
							}}
						/>
					<Banner
						pageLoading={pageLoading}
						bannerData={businessProjectData?.Banner}
						projectName={businessProjectData?.Project_Name} />
					<NavTabsBusiness
						navlist={navBusinessList}
					/>
					<ProjectOverview
						ref={overview}
						projectOverview={businessProjectData?.Project_Overview}
						aboutProject={businessProjectData?.About_Project}
					/>
					<BuildingType
						ref={building}
						title={t("common.office_type")}
						PojectBuilding={businessProjectData?.Office_Building}
						businessProject
					/>
					{businessProjectData?.Construction_Updates &&
						<ConstructionUpdates
							ref={construction}
							Construction={businessProjectData?.Construction_Updates}
						/>}
					<Amenities
						ref={amenities}
						servicesHeader={businessProjectData?.FacilitiesAndServices?.Header}
						services={businessProjectData?.FacilitiesAndServices?.Amenitie_Service}
						projectPage
						businessProject
					/>
					<Enquiry
						ref={enquire}
						projectPage
						businessProject
						projectName={businessProjectData?.Project_Name}
						officeTypes={businessProjectData?.Office_Building}
						bgImg={isMobile ? businessProjectData?.form_image_mobile?.data?.attributes?.url : businessProjectData?.form_image_desktop?.data?.attributes?.url}

					/>
					<Footer />
				</>
				:
				commercialProjectData ?
					//commercial projects structure
					<>
						<NextSeo
							title={commercialData?.data[0]?.attributes?.SEO?.Title}
							description={commercialData?.data[0]?.attributes?.SEO?.Description}
							openGraph={{
								type: 'website',
								url: `https://www.hydeparkdevelopments.com/projects/${slug}`,
								title: commercialData?.data[0]?.attributes?.SEO?.Title,
								images: [
									{ url: BASE_URL + commercialData?.data[0]?.attributes?.SEO?.Img?.data?.attributes?.url },
								],
								siteName: 'Hyde Park Developments',
							}}
						/>
						<Banner
							pageLoading={pageLoading}
							bannerData={commercialProjectData?.Banner}
							projectName={commercialProjectData?.Project_Name}
						/>
						<NavTabsCommercial
							navlist={navCommercialList}
						/>
						<PhaseOverview
							commercialPage
							ref={overview}
							title={commercialProjectData?.About_Project?.Title}
							description={commercialProjectData?.About_Project?.Description}
							usps={commercialProjectData?.About_Project?.Project_Usps}
						/>
						{/* signature outlet*/}
						<Amenities
							ref={signature}
							servicesHeader={commercialProjectData?.Signature_Restaurant?.header}
							services={commercialProjectData?.Signature_Restaurant?.Food_Restaurant}
							projectPage
							commercialServices
							grey
						/>
						{/* foodCourt has the same structure of OurPromises in whoWeAre page */}
						<Amenities
							ref={foodCourt}
							servicesHeader={commercialProjectData?.Food_Court?.header}
							services={commercialProjectData?.Food_Court?.Restaurants}
							servicesDescription={commercialProjectData?.Food_Court?.Description}
							projectPage
							commercialServices

						/>
						<Facilities
							ref={facilities}
							facilitiesData={commercialProjectData?.Facilities}
						/>
						{commercialProjectData?.Construction_Updates &&
							<ConstructionUpdates
								ref={construction}
								Construction={commercialProjectData?.Construction_Updates}
								commercialProject
							/>}
						<Enquiry
							ref={enquire}
							projectPage
							commercialProject
							projectName={commercialProjectData?.Project_Name}
						// bgImg={isMobile ? commercialProjectData?.form_image_mobile?.data?.attributes?.url : commercialProjectData?.form_image_desktop?.data?.attributes?.url}
						/>
						<Footer />
					</>
					:
					//normal projects structure
					projectData &&
					<>
						<NextSeo
							title={data?.data[0]?.attributes?.SEO?.Title}
							description={data?.data[0]?.attributes?.SEO?.Description}
							openGraph={{
								type: 'website',
								url: `https://www.hydeparkdevelopments.com/projects/${slug}`,
								title: data?.data[0]?.attributes?.SEO?.Title,
								images: [
									{ url: BASE_URL + data?.data[0]?.attributes?.SEO?.Img?.data?.attributes?.url },
								],
								siteName: 'Hyde Park Developments',
							}}
						/>
						<Banner
							pageLoading={pageLoading}
							bannerData={projectData?.Banner} projectName={projectData?.Project_Name} />
						{projectData?.Commercial_Services?.Show_In_Website ?
							<NavTabsWithCommercialServices navlist={navlistWithCommercialServices} /> :
							<NavTabs navlist={navlist} />}
						<ProjectOverview ref={overview} projectOverview={projectData?.Project_Overview} aboutProject={projectData?.About_Project} />
						<Masterplan ref={masterplan} masterplanData={projectData?.Project_Master_Plan} projectPhases={orderedPhases} projectSlug={projectData?.Slug} masterPlanFacilities={masterPlanFacilities} />
						<Amenities
							ref={amenities}
							servicesHeader={projectData?.Amenities_Services?.Header}
							services={projectData?.Amenities_Services?.Amenitie_Service}
							projectPage />
						<Facilities ref={facilities} facilitiesData={projectData?.Facilities} />
						<Landmarks ref={landmarks} landmarksData={projectData?.Landmarks} commercialPage={projectData?.Commercial_Services?.Show_In_Website} />
						{projectData?.Commercial_Services?.Show_In_Website ? <Amenities
							ref={commercialServices}
							servicesHeader={projectData?.Commercial_Services?.Header}
							services={projectData?.Commercial_Services?.Services}
							projectPage
							commercialServices /> : ""}
						{projectData?.Construction_Updates &&
							<ConstructionUpdates
								ref={construction}
								Construction={projectData?.Construction_Updates}
							/>}
						<SimilarProjects ref={similarProjects} similarProjects={projectData?.Similar_Projects} />
						<Enquiry
							bgImg={isMobile ? projectData?.form_image_mobile?.data?.attributes?.url : projectData?.form_image_desktop?.data?.attributes?.url}
							ref={enquire} projectPage phases={projectData?.phases?.data} projectName={projectData?.Project_Name} />
						<Footer />
					</>

			}
		</>
	);
};

export default index;
export async function getServerSideProps({ locale, params }) {
	const { slug } = params
	const queryClient = new QueryClient();
	// await queryClient.prefetchQuery(['projectDetails'], () => fetchDynamicData(
	// 	'projects',
	// 	slug,
	// 	locale,
	// 	'populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=Project_Overview.Project_Info.Icon&populate[3]=Project_Master_Plan.Map_Mobile&populate[4]=Project_Master_Plan.Map_Desktop&populate[5]=Project_Master_Plan.Phase_Project.Logo&populate[6]=Project_Master_Plan.Phase_Project.Icon&populate[7]=Project_Master_Plan.Phase_Project.Pdf&populate[8]=Project_Master_Plan.Phase_Project.Img_Desktop&populate[9]=Project_Master_Plan.Phase_Project.Img_Mobile&populate[10]=Project_Master_Plan.Phase_Project.Thumbnails_Mobile&populate[11]=Project_Master_Plan.Phase_Project.Thumbnails_Desktop&populate[12]=Amenities_Services.Amenitie_Service.Icon&populate[13]=Facilities.Img_Desktop&populate[14]=Facilities.Img_Mobile&populate[15]=Facilities.Our_Facilities.Img_Desktop&populate[16]=Facilities.Our_Facilities.Img_Mobile&populate[17]=Landmarks.Img_Desktop&populate[18]=Landmarks.Img_Mobile&populate[19]=Project_Card.Img_Mobile&populate[20]=Project_Card.Project_Info.Icon&populate[21]=Project_Card.Img_Desktop&populate[22]=Home_Card.Img_Desktop&populate[23]=Home_Card.Img_Mobile&populate[24]=Home_Card.Logo&populate[25]=Similar_Projects.Projects&populate[26]=Similar_Projects.Phases&populate[27]=Similar_Projects.Projects.Project_Card.Img_Mobile&populate[28]=Similar_Projects.Projects.Project_Card.Project_Info.Icon&populate[29]=Similar_Projects.Projects.Project_Card.Img_Desktop&populate[30]=phases&populate[31]=phases.Master_Plan_Card&populate[32]=phases.Master_Plan_Card.Icon&populate[33]=phases.Master_Plan_Card.Pdf&populate[34]=phases.Master_Plan_Card.Img_Desktop&populate[35]=phases.Master_Plan_Card.Img_Mobile&populate[36]=phases.Master_Plan_Card.Thumbnails_Desktop&populate[38]=phases.Master_Plan_Card.Logo&populate[39]=About_Project&populate[40]=About_Project.Project_Usps.Small_Img_Mobile&populate[41]=About_Project.Project_Usps.Small_Img_Desktop&populate[42]=About_Project.Project_Usps.Big_Img_Mobile&populate[43]=About_Project.Project_Usps.Big_Img_Desktop&populate[44]=Commercial_Services&populate[45]=Commercial_Services.Services&populate[46]=Commercial_Services.Services.Icon&populate[47]=Construction_Updates.Main_Slider.Img_Mobile&populate[48]=Construction_Updates.Main_Slider.Img_Desktop&populate[49]=Construction_Updates.Sub_Slider.Img_Desktop&populate[50]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[51]=phases.Phase_Building&&populate[52]=form_image_desktop&&populate[53]=form_image_mobile&&populate[54]=Facilities.Our_Facilities.Masterplan_Img_Mobile&&populate[55]=Facilities.Our_Facilities.Masterplane_Img_Desktop&&populate[56]=Facilities.Our_Facilities.Masterplane_Description&&populate[57]=Construction_Updates.Main_Slider.Sub_Slider_Img'
	// ), {
	// 	enabled: slug?.slice(0, 2) != "Cp" && slug?.slice(0, 2) != "Bp"
	// })
	await queryClient.prefetchQuery(['projectDetailsBusiness'], () => fetchDynamicData(
		'businesses',
		slug,
		locale,
		'populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=About_Project.Project_Usps.Small_Img_Desktop&populate[3]=About_Project.Project_Usps.Small_Img_Mobile&populate[4]=About_Project.Project_Usps.Big_Img_Desktop&populate[5]=About_Project.Project_Usps.Big_Img_Mobile&populate[6]=Office_Building.Img_Desktop&populate[7]=Office_Building.Img_Mobile&populate[8]=Office_Building.Building_Details.Icon&populate[9]=Office_Building.Pdf&populate[10]=FacilitiesAndServices.Amenitie_Service.Icon&populate[11]=project_tabs&populate[12]=Home_Card.Img_Desktop&populate[13]=Home_Card.Img_Mobile&populate[14]=Home_Card.Img_Logo&populate[15]=Project_Overview.Project_Info.Icon&populate[16]=Construction_Updates.Main_Slider.Img_Mobile&populate[17]=Construction_Updates.Main_Slider.Img_Desktop&populate[18]=Construction_Updates.Sub_Slider.Img_Desktop&populate[19]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[20]=Facilities.Our_Facilities.Masterplan_Img_Mobile&&populate[21]=Facilities.Our_Facilities.Masterplane_Img_Desktop&&populate[22]=Facilities.Our_Facilities.Masterplane_Description&&populate[23]=form_image_desktop&&populate[24]=form_image_mobile&&populate[25]=Construction_Updates.Main_Slider.Sub_Slider_Img&&populate[26]=SEO.Img'
	), {
		enabled: slug?.slice(0, 2) == "Bp"
	})
	await queryClient.prefetchQuery(['projectDetailsCommercial'], () => fetchDynamicData(
		'commercials',
		slug,
		locale,
		'populate[0]=Banner.Slider&populate[1]=Banner.Slider.Img_Desktop&populate[2]=Banner.Slider.Img_Mobile&populate[3]=About_Project.Project_Usps.Small_Img_Desktop&populate[4]=About_Project.Project_Usps.Small_Img_Mobile&populate[5]=About_Project.Project_Usps.Big_Img_Desktop&populate[6]=About_Project.Project_Usps.Big_Img_Mobile&populate[7]=Master_Plan.Img_Desktop&populate[8]=Master_Plan.Img_Mobile&populate[9]=Signature_Restauran.Food_Restaurant.img_desktop&populate[10]=Signature_Restaurant.Food_Restaurant.img_mobile&populate[11]=Food_Court.Restaurants.Icon&populate[12]=Facilities.Img_Desktop&populate[13]=Facilities.Img_Mobile&populate[14]=Facilities.Our_Facilities.Img_Desktop&populate[15]=Facilities.Our_Facilities.Img_Mobile&populate[16]=project_tabs.commercial_projects&populate[17]=Signature_Restaurant.Food_Restaurant.Icon&populate[18]=Construction_Updates.Main_Slider.Img_Mobile&populate[19]=Construction_Updates.Main_Slider.Img_Desktop&populate[20]=Construction_Updates.Sub_Slider.Img_Desktop&populate[21]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[22]=Facilities.Our_Facilities.Masterplan_Img_Mobile&&populate[23]=Facilities.Our_Facilities.Masterplane_Img_Desktop&&populate[24]=Facilities.Our_Facilities.Masterplane_Description&&populate[25]=form_image_desktop&&populate[26]=form_image_mobile&&populate[27]=Construction_Updates.Main_Slider.Sub_Slider_Img&&populate[28]=SEO.Img'
	), {
		enabled: slug?.slice(0, 2) == "Cp"
	})

	const projresponse = await fetchDynamicData(
		'projects',
		slug,
		locale,
		'populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=Project_Overview.Project_Info.Icon&populate[3]=Project_Master_Plan.Map_Mobile&populate[4]=Project_Master_Plan.Map_Desktop&populate[5]=Project_Master_Plan.Phase_Project.Logo&populate[6]=Project_Master_Plan.Phase_Project.Icon&populate[7]=Project_Master_Plan.Phase_Project.Pdf&populate[8]=Project_Master_Plan.Phase_Project.Img_Desktop&populate[9]=Project_Master_Plan.Phase_Project.Img_Mobile&populate[10]=Project_Master_Plan.Phase_Project.Thumbnails_Mobile&populate[11]=Project_Master_Plan.Phase_Project.Thumbnails_Desktop&populate[12]=Amenities_Services.Amenitie_Service.Icon&populate[13]=Facilities.Img_Desktop&populate[14]=Facilities.Img_Mobile&populate[15]=Facilities.Our_Facilities.Img_Desktop&populate[16]=Facilities.Our_Facilities.Img_Mobile&populate[17]=Landmarks.Img_Desktop&populate[18]=Landmarks.Img_Mobile&populate[19]=Project_Card.Img_Mobile&populate[20]=Project_Card.Project_Info.Icon&populate[21]=Project_Card.Img_Desktop&populate[22]=Home_Card.Img_Desktop&populate[23]=Home_Card.Img_Mobile&populate[24]=Home_Card.Logo&populate[25]=Similar_Projects.Projects&populate[26]=Similar_Projects.Phases&populate[27]=Similar_Projects.Projects.Project_Card.Img_Mobile&populate[28]=Similar_Projects.Projects.Project_Card.Project_Info.Icon&populate[29]=Similar_Projects.Projects.Project_Card.Img_Desktop&populate[30]=phases&populate[31]=phases.Master_Plan_Card&populate[32]=phases.Master_Plan_Card.Icon&populate[33]=phases.Master_Plan_Card.Pdf&populate[34]=phases.Master_Plan_Card.Img_Desktop&populate[35]=phases.Master_Plan_Card.Img_Mobile&populate[36]=phases.Master_Plan_Card.Thumbnails_Desktop&populate[38]=phases.Master_Plan_Card.Logo&populate[39]=About_Project&populate[40]=About_Project.Project_Usps.Small_Img_Mobile&populate[41]=About_Project.Project_Usps.Small_Img_Desktop&populate[42]=About_Project.Project_Usps.Big_Img_Mobile&populate[43]=About_Project.Project_Usps.Big_Img_Desktop&populate[44]=Commercial_Services&populate[45]=Commercial_Services.Services&populate[46]=Commercial_Services.Services.Icon&populate[47]=Construction_Updates.Main_Slider.Img_Mobile&populate[48]=Construction_Updates.Main_Slider.Img_Desktop&populate[49]=Construction_Updates.Sub_Slider.Img_Desktop&populate[50]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[51]=phases.Phase_Building&&populate[52]=form_image_desktop&&populate[53]=form_image_mobile'
	)
	const businessProjresponse = await fetchDynamicData(
		'businesses',
		slug,
		locale,
		'populate[0]=Banner.Slider.Img_Desktop&populate[1]=Banner.Slider.Img_Mobile&populate[2]=About_Project.Project_Usps.Small_Img_Desktop&populate[3]=About_Project.Project_Usps.Small_Img_Mobile&populate[4]=About_Project.Project_Usps.Big_Img_Desktop&populate[5]=About_Project.Project_Usps.Big_Img_Mobile&populate[6]=Office_Building.Img_Desktop&populate[7]=Office_Building.Img_Mobile&populate[8]=Office_Building.Building_Details.Icon&populate[9]=Office_Building.Pdf&populate[10]=FacilitiesAndServices.Amenitie_Service.Icon&populate[11]=project_tabs&populate[12]=Home_Card.Img_Desktop&populate[13]=Home_Card.Img_Mobile&populate[14]=Home_Card.Img_Logo&populate[15]=Project_Overview.Project_Info.Icon&populate[16]=Construction_Updates.Main_Slider.Img_Mobile&populate[17]=Construction_Updates.Main_Slider.Img_Desktop&populate[18]=Construction_Updates.Sub_Slider.Img_Desktop&populate[19]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[20]=form_image_desktop&&populate[21]=form_image_mobile'
	)
	const CommercialProjresponse = await fetchDynamicData(
		'commercials',
		slug,
		locale,
		'populate[0]=Banner.Slider&populate[1]=Banner.Slider.Img_Desktop&populate[2]=Banner.Slider.Img_Mobile&populate[3]=About_Project.Project_Usps.Small_Img_Desktop&populate[4]=About_Project.Project_Usps.Small_Img_Mobile&populate[5]=About_Project.Project_Usps.Big_Img_Desktop&populate[6]=About_Project.Project_Usps.Big_Img_Mobile&populate[7]=Master_Plan.Img_Desktop&populate[8]=Master_Plan.Img_Mobile&populate[9]=Signature_Restauran.Food_Restaurant.img_desktop&populate[10]=Signature_Restaurant.Food_Restaurant.img_mobile&populate[11]=Food_Court.Restaurants.Icon&populate[12]=Facilities.Img_Desktop&populate[13]=Facilities.Img_Mobile&populate[14]=Facilities.Our_Facilities.Img_Desktop&populate[15]=Facilities.Our_Facilities.Img_Mobile&populate[16]=project_tabs.commercial_projects&populate[17]=Signature_Restaurant.Food_Restaurant.Icon&populate[18]=Construction_Updates.Main_Slider.Img_Mobile&populate[19]=Construction_Updates.Main_Slider.Img_Desktop&populate[20]=Construction_Updates.Sub_Slider.Img_Desktop&populate[21]=Construction_Updates.Sub_Slider.Img_Mobile&&populate[22]=form_image_desktop&&populate[23]=form_image_mobile'
	)
	if (
		(CommercialProjresponse.data == null || CommercialProjresponse.data.length == 0) &&
		(projresponse.data == null || projresponse.data.length == 0) &&
		(businessProjresponse.data == null || businessProjresponse.data.length == 0)
	) {
		return {
			notFound: true,
		}
	}
	return {
		props: {
			slug: slug,
			dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
			...(await serverSideTranslations(locale, ["common"])),
		},
	};
}

